import React, { memo } from 'react';

import { Logo as WaitroseLogo } from '@johnlewispartnership/wtr-ingredients/ingredients/Logo/index.js';

import styles from './FooterBadges.module.scss';

type FooterBadgesProps = {
  data: {
    copyright: string;
  };
};

const FooterBadges = memo(({ data: { copyright } }: FooterBadgesProps) => (
  <div className={styles.badges}>
    <div className={styles.logoWrapper}>
      <span className={styles.logo}>
        <WaitroseLogo optimised width={100} />
      </span>
      <small className={styles.copyright}>{copyright}</small>
    </div>
  </div>
));

FooterBadges.displayName = 'FooterBadges';

export default FooterBadges;
